/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
// Mysql specific attributes not covered by semantic conventions
export enum AttributeNames {
  MYSQL_VALUES = 'db.mysql.values',
}
